import {
  Modal,
  Stack,
  Typography,
  IconButton,
  Tabs,
  Checkbox,
  Tab,
  Card,
  CardActions,
  Box,
  useMediaQuery,
  useTheme,
  Grid,
  TextField,
  Divider,
  CardMedia,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  Button
} from "@mui/material";
import NorthWestIcon from "@mui/icons-material/NorthWest";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import { ArrowUpwardRounded, Edit as EditIcon } from "@mui/icons-material";
import ErrorIcon from "@mui/icons-material/Error";
import GroupIcon from "@mui/icons-material/Group";
import { BIBlue } from "../../assets/helpers";
import { English } from "../../constant/EnglishFallback";
import { useSelector } from "react-redux";

const TicketsTutorial = (props) => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const {
    TEXT_MY_TICKETS = English?.TicketsTutorial?.TEXT_MY_TICKETS,
    TEXT_SHARED_WITH_ME = English?.TicketsTutorial?.TEXT_SHARED_WITH_ME,
    TEXT_TICKETS = English?.TicketsTutorial?.TEXT_TICKETS,
    TEXT_TT_PAGE_ONE_SUBHEADER_ONE = English?.TicketsTutorial?.TEXT_TT_PAGE_ONE_SUBHEADER_ONE,
    TEXT_TUTORIAL_MODAL_ANYWHERE_BTN = English?.TicketsTutorial?.TEXT_TUTORIAL_MODAL_ANYWHERE_BTN,
    TEXT_TT_PAGE_TWO_SUBHEADER_ONE = English?.TicketsTutorial?.TEXT_TT_PAGE_TWO_SUBHEADER_ONE,
    TEXT_TT_PAGE_THREE_SUBHEADER_ONE = English?.TicketsTutorial?.TEXT_TT_PAGE_THREE_SUBHEADER_ONE,
    TEXT_TT_PAGE_FOUR_SUBHEADER_ONE = English?.TicketsTutorial?.TEXT_TT_PAGE_FOUR_SUBHEADER_ONE,
    TEXT_TT_PAGE_FOUR_SUBHEADER_TWO = English?.TicketsTutorial?.TEXT_TT_PAGE_FOUR_SUBHEADER_TWO
  } = multiLanguageData?.TicketsTutorial || {};

  const {
    BUTTON_TEXT_ADD_TICKET = English?.Tickets?.BUTTON_TEXT_ADD_TICKET,
    TEXT_TICKET_TYPE = English?.Tickets?.TEXT_TICKET_TYPE,
    TEXT_TICKET_TYPE_ALL = English?.Tickets?.TEXT_TICKET_TYPE_ALL,
    TEXT_SORT_BY_FILTER_PLACEHOLDER = English?.Tickets?.TEXT_SORT_BY_FILTER_PLACEHOLDER,
    TEXT_SORT_BY_RECENT = English?.Tickets?.TEXT_SORT_BY_RECENT
  } = multiLanguageData?.Tickets || {};

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const drawerWidth = 240;

  const allState = {
    value: 0,
    filter: "All",
    sorting: "Recent",
    inputText: ""
  };

  const isExpired = (expiryDate) => {
    if (expiryDate === "" || expiryDate === null) return;
    const currentDate = new Date();
    const expiry = new Date(expiryDate);
    return expiry < currentDate;
  };

  const myTickets = [
    {
      id: 1041,
      ticketTypeId: 48,
      ticketType: "Safety Orientation",
      expiry: "2025-06-03T18:30:00",
      ticketId: "545",
      issuedById: 940,
      issuedBy: "A&E Architectural.",
      issuedOn: "2025-05-31T18:30:00",
      publicTicket: false,
      frontPictureUrl: "",
      backPictureUrl: "",
      recordStatus: "Visible",
      userId: 8,
      sharedTicketsList: [],
      isSelected: false
    },
    {
      id: 1040,
      ticketTypeId: 36,
      ticketType: "This is a test",
      expiry: "2025-06-05T18:30:00",
      ticketId: "12",
      issuedById: 595,
      issuedBy: "4 Architecture Inc",
      issuedOn: "2025-06-03T18:30:00",
      publicTicket: false,
      frontPictureUrl: "",
      backPictureUrl: "",
      recordStatusId: 2,
      recordStatus: "Visible",
      userId: 8,
      sharedTicketsList: [
        {
          id: 1578,
          ticketId: 1040
        }
      ],
      isSelected: false
    }
  ];

  const shareTickets = [
    {
      id: 1042,
      ticketTypeId: 36,
      ticketType: "This is a test",
      expiry: "2025-06-05T18:30:00",
      ticketId: "12",
      issuedById: 595,
      issuedBy: "4 Architecture Inc",
      issuedOn: "2025-06-03T18:30:00",
      publicTicket: false,
      frontPictureUrl: "",
      backPictureUrl: "",
      createdBy: 8,
      dateCreated: "2025-06-04T10:35:40.03",
      modifiedBy: 8,
      dateModified: "2025-06-04T10:35:40.03",
      noOfUsersSharedWith: 1,
      ticketOwner: "Tejashree Bhuse",
      createdByUser: "Tejashree Bhuse",
      modifiedByUser: "Tejashree Bhuse",
      recordStatusId: 2,
      recordStatus: "Visible",
      userId: 8,
      sharedTicketsList: [
        {
          id: 1578,
          ticketId: 1040
        }
      ],
      isSelected: false
    }
  ];

  const TicketCard = ({ ticket, isExpired, BIBlue }) => {
    return (
      <Grid
        key={ticket.id} // Prefer a stable and unique id if available
        size={{ xs: ticket.id === 1042 ? 12 : 6, sm: 6, md: 6, lg: 4, xl: 3 }}>
        <Card
          className="pagelist-content"
          sx={{
            backgroundColor: isExpired(ticket.expiry) === true ? "#FABEBE" : ""
          }}>
          <CardMedia component="img" height="200" image={ticket?.frontPictureUrl} />
          <CardActions disableSpacing sx={{ flexDirection: "column", alignItems: "baseline" }}>
            <Stack direction="row" spacing={0.1} sx={{ justifyContent: "space-between" }} width={"100%"}>
              <Stack direction={"row"} sx={{ alignItems: "center" }}>
                <Checkbox
                  color="primary"
                  checked={ticket.isSelected}
                  inputProps={{ "aria-label": "controlled" }}
                  sx={{
                    color: BIBlue,
                    padding: "0px"
                  }}
                />
                <Typography variant="body1" maxWidth={"170px"} noWrap>
                  {ticket?.ticketType}
                </Typography>
              </Stack>
              <Stack direction={"row"} sx={{ alignItems: "center" }}>
                {isExpired(ticket.expiry) === true && (
                  <IconButton color="secondary" size="small" aria-label="add to favorites">
                    <ErrorIcon fontSize="small" />
                  </IconButton>
                )}
                {ticket.sharedTicketsList?.length !== 0 && (
                  <IconButton color="default" size="small" aria-label="group">
                    <GroupIcon fontSize="small" />
                  </IconButton>
                )}
                <IconButton color="primary" size="small" aria-label="edit">
                  <EditIcon fontSize="small" />
                </IconButton>
              </Stack>
            </Stack>
            <Typography sx={{ pl: 1 }} variant="body1" maxWidth={"250px"} noWrap>
              {ticket?.issuedBy}
            </Typography>
          </CardActions>
        </Card>
      </Grid>
    );
  };

  return (
    <>
      <Modal open={props?.tutorialIndex === 0 ? false : true}>
        <Box sx={{ backgroundColor: "rgba(0, 0, 0, 0.7)", height: "100%" }} onClick={props.onPress}>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`, // Dynamically set height
              overflowY: "auto",
              mt: `${theme.mixins.toolbar.minHeight}px`, // Push content below AppBar
              width: { sm: props.tutorialIndex === 1 ? "100%" : `calc(100% - ${drawerWidth}px)` }, // Ensure content doesn't go behind Sidebar
              marginLeft: { sm: props.tutorialIndex === 1 ? 0 : `${drawerWidth}px`, xs: 0 }
            }}>
            <Box
              className="main-content-Box"
              sx={{ p: isSmallScreen ? 2 : 3, pt: 2, backgroundColor: "transparent" }}>
              {props.tutorialIndex === 1 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh"
                  }}>
                  <Stack sx={{ textAlign: "center", color: "white" }}>
                    <Typography variant="h6">{TEXT_TICKETS}</Typography>
                    <Typography variant="subtitle1">{TEXT_TT_PAGE_ONE_SUBHEADER_ONE}</Typography>
                    <Typography variant="body1">
                      <span style={{ color: BIBlue }}>
                        {" "}
                        {`(${TEXT_TUTORIAL_MODAL_ANYWHERE_BTN})`}
                      </span>
                    </Typography>
                  </Stack>
                </Box>
              )}

              {props.tutorialIndex === 2 && (
                <>
                  <Box className={"main-content-Box"}>
                    <Card
                      className="main-content-card"
                      sx={{
                        mt: { xs: 5, md: 5 },
                        backgroundColor: "transparent !important",
                        border: "none",
                        p: 0
                      }}>
                      <Box sx={{ height: "80px", backgroundColor: "white", p: 2 }}>
                        <Grid
                          container
                          spacing={{ xs: 1, md: 2 }}
                          sx={{ pb: 1, 
                            alignItems: "center"
                          }}
                          >
                          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 3.5, xl: 3.5 }}>
                            <Tabs
                              variant="fullWidth"
                              aria-label="basic tabs example"
                              value={allState.value}>
                              <Tab label={TEXT_MY_TICKETS} />
                              <Tab label={TEXT_SHARED_WITH_ME} />
                            </Tabs>
                          </Grid>
                          <Grid
                            sx={{ display: { xs: "none", md: "block" } }}
                            size={{ xs: 12, sm: 12, md: 12, lg: 3.5, xl: 3.5 }}>
                            <Stack direction={"row"} sx={{ justifyContent: "flex-end" }} spacing={1}>
                              <TextField
                                fullWidth
                                id="outlined-basic"
                                label={"Search My Tickets"}
                                variant="outlined"
                                size="small"
                                value={allState.inputText}
                              />
                            </Stack>
                          </Grid>

                          <Grid sx={{ pt: { xs: 1, md: 0 ,  justifyContent: "end", alignItems: "center" }} } size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }}>
                            <Stack direction={"row"} sx={{ justifyContent: "flex-end" }} spacing={1}>
                              {allState?.value === 0 && (
                                <Box sx={{ display: { xs: "none", md: "flex" }, width: "100%" }}>
                                  <FormControl size="small" sx={{ width: "100%" }}>
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      {TEXT_TICKET_TYPE}
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={allState.filter}
                                      sx={{ width: "100%" }}
                                      label="Ticket type">
                                      <MenuItem value={"All"}>{TEXT_TICKET_TYPE_ALL}</MenuItem>
                                    </Select>
                                  </FormControl>
                                  <FormControl size="small" sx={{ width: "100%" }}>
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      {TEXT_SORT_BY_FILTER_PLACEHOLDER}
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={allState.sorting}
                                      sx={{ width: "100%" }}
                                      label="Sort By">
                                      <MenuItem value={"Recent"}>{TEXT_SORT_BY_RECENT}</MenuItem>
                                    </Select>
                                  </FormControl>
                                  <Button fullWidth variant="contained" sx={{ background: BIBlue }}>
                                    {BUTTON_TEXT_ADD_TICKET}
                                  </Button>
                                </Box>
                              )}
                            </Stack>
                          </Grid>
                        </Grid>
                        <Divider />
                      </Box>
                      <Stack
                        direction={"column"}
                        sx={{ ml: 5, textAlign: "center", color: "white", width: "400px" }}>
                        <IconButton>
                          <ArrowUpwardRounded style={{ fontSize: "30px", color: "white" }} />
                        </IconButton>
                        <Typography variant="subtitle1">
                          {TEXT_TT_PAGE_TWO_SUBHEADER_ONE}
                        </Typography>
                      </Stack>
                    </Card>
                  </Box>
                </>
              )}

              {(props.tutorialIndex === 3 || props.tutorialIndex === 4) && (
                <>
                  <Box
                    sx={{
                      mt: { xs: 15.7, sm: 24.7, md: 13.7 },
                      height: { xs: "280px", sm: "300px" },
                      p: 2,
                      pb: 0
                    }}>
                    <Box className="main-content-card-list">
                      <Grid container spacing={{ xs: 1.5, md: 2 }}>
                        {(props.tutorialIndex === 3 ? myTickets : shareTickets)?.map((ticket) => (
                          <TicketCard
                            key={ticket.id}
                            ticket={ticket}
                            isExpired={isExpired}
                            BIBlue={BIBlue}
                          />
                        ))}
                      </Grid>
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {props.tutorialIndex === 3 ? (
                      <Stack sx={{ alignItems: "center", color: "white" }}>
                        <Stack spacing={2} direction="row" sx={{ justifyContent: "flex-start" }}>
                          <NorthWestIcon style={{ fontSize: "35px" }} />
                          <NorthEastIcon style={{ fontSize: "35px" }} />
                        </Stack>
                        <Typography variant="subtitle1">
                          {TEXT_TT_PAGE_THREE_SUBHEADER_ONE}
                        </Typography>
                      </Stack>
                    ) : (
                      props.tutorialIndex === 4 && (
                        <Stack sx={{ alignItems: "flex-start", color: "white" }}>
                          <Stack direction="row" sx={{ ml: 5,  justifyContent: "flex-start" }} >
                            <NorthWestIcon style={{ fontSize: "35px" }} />
                          </Stack>
                          <Typography variant="subtitle1">
                            {TEXT_TT_PAGE_FOUR_SUBHEADER_ONE}
                          </Typography>
                          <Typography variant="subtitle1">
                            {TEXT_TT_PAGE_FOUR_SUBHEADER_TWO}
                          </Typography>
                        </Stack>
                      )
                    )}
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default TicketsTutorial;
